import { IS_DEV, SNP_ENCODER, SNP_JUMPLED, WEBSITE_SHOP_HASH } from "./constant";

export function isEmpty(val) {
    if (val === undefined) return true;
    if (val === null) return true;
    return (val.length <= 0) ? true : false;
}


export const jumbleString = (input) => {
    const level = input.length / SNP_JUMPLED;
    //printDebugLog("jumbleString",SNP_JUMPLED);
    const parts = [input.substring(0, level), input.substring(level)];
    return (
        parts[0].split("").reverse().join("") +
        parts[1].split("").reverse().join("")
    );
}
export const encode = (input) => {
    input = jumbleString(input);
    let word = "";
    for (let index = 0; index < input.length; index++) {
        const c = input.charCodeAt(index) + Number(SNP_ENCODER);
        word = word + String.fromCharCode(c);
    }
    return word;
}
export const decode = (input) => {
    if (isEmpty(input)) return input;
    let org = "";
    for (let index = 0; index < input.length; index++) {
        const c = input.charCodeAt(index) - Number(SNP_ENCODER);
        org = org + String.fromCharCode(c);
    }
    org = jumbleString(org);
    return org;
}

export const printDebugLog = (first, ...msg) => {
    if (!IS_DEV) return;
    console.log(first, msg);
}

export const buildProductFilter = (
    categoryFilter = [],
    //priceRange = [],
    brandFilter = [],
    //sortByPriceFilter = "",
    filterListMovementType = "",
    filterListPersons = "",
    filterConditions = "") => {
    const data = {
        jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            listCatgId: (categoryFilter ?? []).map(item => item?._id).filter(Boolean),
            // isHighPrice: isEmpty(sortByPriceFilter) ? null : "desc" === sortByPriceFilter ? true : "asc" === sortByPriceFilter ? false : null,
            // lowPrice: Array.isArray(priceRange) && priceRange.length > 0 ? priceRange[0] : 0.0,
            // highPrice: Array.isArray(priceRange) && priceRange.length > 1 ? priceRange[1] : 0.0,
            listBrand: brandFilter,
            movementType: filterListMovementType,
            gender: filterListPersons,
            condition: filterConditions,
        },
    };
    return data;
};

export const buildProductEmpty = () => {
    const data = {
        jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
        },
    };
    return data;
};

export const parseTimeString = (timeString) => {
    const regex = /(?:(\d+)d)?(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/;
    const match = timeString.match(regex);

    return {
        day: match[1] ? parseInt(match[1], 10) : 0,
        hour: match[2] ? parseInt(match[2], 10) : 0,
        minute: match[3] ? parseInt(match[3], 10) : 0,
        second: match[4] ? parseInt(match[4], 10) : 0,
    };
};

export const formatTimeString = ({ day, hour, minute, second }) => {
    return `${day}d${hour}h${minute}m${second}s`;
};

export const getAddressUtils = (addr) => {
    const addressParts = [
        addr.landMark,
        addr.address,
        addr.city,
        addr.state,
        addr.country,
        addr.zipCode
    ].filter(Boolean); // removes null, undefined, and empty strings

    const address = addressParts.join(", ");
    return [
        addr.name && `Name: ${addr.name}`,
        address && `Address: ${address}`,
        addr.mobileNum && `Mobile: ${addr.mobileNum}`,
    ].filter(Boolean).join("\n");
}

export const toUpperCase = (str) => {
    if (isEmpty(str)) {
        return "";
    }
    return str.toUpperCase();
}
